import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { PROJECT_TYPE_OPTIONS, getProjectTypeColor } from "../../config/projectTypeColors";

export function CreateProjectDialog({ open, onOpenChange, formData, setFormData, onSubmit, saving }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>Neues Projekt</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label>Projektname *</Label>
            <Input value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="z.B. Amazon Dortmund" data-testid="project-name-input" autoFocus />
          </div>
          <div>
            <Label>Beschreibung</Label>
            <Textarea value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} placeholder="Optionale Beschreibung..." rows={2} data-testid="project-description-input" />
          </div>
          <div>
            <Label>Projekttyp</Label>
            <select
              value={formData.project_type}
              onChange={e => setFormData({ ...formData, project_type: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-sm rounded-md focus:outline-none"
              style={{
                background: "var(--tga-bg-content)",
                border: "1px solid var(--tga-border)",
                color: "var(--tga-text-primary)",
              }}
              data-testid="project-type-select"
            >
              {PROJECT_TYPE_OPTIONS.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
            <div className="flex items-center gap-2 mt-2">
              <div className="w-4 h-4 rounded-full" style={{ backgroundColor: getProjectTypeColor(formData.project_type), boxShadow: "0 0 0 1px var(--tga-border-strong)" }} />
              <span className="text-[11px]" style={{ color: "var(--tga-text-muted)" }}>Farbe wird automatisch gesetzt</span>
            </div>
          </div>
          <div style={{ borderTop: "1px solid var(--tga-border)", paddingTop: 16 }}>
            <p className="text-sm font-medium mb-3" style={{ color: "var(--tga-text-secondary)" }}>Controlling</p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Budget (Euro)</Label>
                <Input type="number" step="0.01" min="0" value={formData.budget} onChange={e => setFormData({ ...formData, budget: e.target.value })} placeholder="z.B. 50000" data-testid="project-budget-input" />
              </div>
              <div>
                <Label>Soll-Stunden</Label>
                <Input type="number" step="0.5" min="0" value={formData.planned_hours} onChange={e => setFormData({ ...formData, planned_hours: e.target.value })} placeholder="z.B. 500" data-testid="project-hours-input" />
              </div>
            </div>
            <div className="mt-3">
              <Label>Kilometer-Kosten (Euro/km)</Label>
              <Input type="number" step="0.01" min="0" value={formData.km_cost_per_km} onChange={e => setFormData({ ...formData, km_cost_per_km: e.target.value })} placeholder="0.30" data-testid="project-km-cost-input" />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="cancel-create-project-btn">Abbrechen</Button>
          <Button
            onClick={onSubmit}
            disabled={saving || !formData.name.trim()}
            style={{ background: "var(--tga-blue)", color: "#fff" }}
            data-testid="confirm-create-project-btn"
          >
            {saving ? "Erstelle..." : "Projekt erstellen"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
